import { Fragment } from "react";

import type { WorkingArea } from "@utils";

import { SpecializationInline } from "./SpecializationInline";
import { SectionContainer, SectionHeader } from "./Specializations.styled";
import { SpecializationsSection } from "./SpecializationsSection";

export interface SpecializationInlineData {
  splineCodeSrc: string;
  fallbackSrc: string;
  colorKey: WorkingArea;
  text: string;
}

export interface SpecializationSectionData {
  colorKey?: WorkingArea;
  ctaText: string;
  href?: string;
  seeMoreHref?: string;
  header?: {
    splineCodeSrc?: string;
    fallbackSrc?: string;
    title: string;
    description: string;
    seeMoreText: string;
  };
  contents: {
    header: string;
    body: string;
  }[];
}

export interface SpecializationsContent {
  header: string;
  subheaderParts: string[];
  inlineItems: SpecializationInlineData[];
  sections: SpecializationSectionData[];
  ctaBaseText: string;
}

export interface SpecializationsProps extends SpecializationsContent {
  className?: string;
}

export const Specializations = ({
  header,
  subheaderParts,
  inlineItems,
  sections,
  ctaBaseText,
  className,
}: SpecializationsProps) => {
  return (
    <div className={`my-12 ${className}`}>
      <SectionHeader>
        <h2>{header}</h2>

        <div>
          {inlineItems.map((item, index) => (
            <Fragment key={index}>
              {subheaderParts[index]}
              <SpecializationInline
                splineCodeSrc={item.splineCodeSrc}
                fallbackSrc={item.fallbackSrc}
                colorKey={item.colorKey}
              >
                {item.text}
              </SpecializationInline>
            </Fragment>
          ))}
        </div>
      </SectionHeader>

      <SectionContainer>
        {sections.map((section, index) => (
          <SpecializationsSection
            key={index}
            colorKey={section.colorKey ?? "embedded"}
            ctaText={section.ctaText}
            ctaBaseText={ctaBaseText}
            href={section.href}
            seeMoreHref={section.seeMoreHref}
            header={section.header}
            contents={section.contents}
          />
        ))}
      </SectionContainer>
    </div>
  );
};
